import React from 'react';
import { Star } from 'lucide-react';
import CrudManager from '../../components/admin/CrudManager';
import { getReviews, createReview, updateReview, deleteReview } from '../../utils/api';

const fields = [
  { name: 'name', label: 'Reviewer Name', type: 'text', required: true },
  { name: 'designation', label: 'Designation', type: 'text', placeholder: 'e.g. Professor' },
  { name: 'review', label: 'Review Text', type: 'textarea', required: true },
  { name: 'rating', label: 'Rating', type: 'rating' },
  { name: 'image', label: 'Reviewer Photo', type: 'image' },
];

export default function AdminReviews() {
  return (
    <CrudManager
      title="Reviews"
      subtitle="Manage reader testimonials"
      fields={fields}
      fetchFn={getReviews}
      createFn={createReview}
      updateFn={updateReview}
      deleteFn={deleteReview}
      emptyDefaults={{ rating: 5 }}
      cardRenderer={(item) => (
        <div className="p-4">
          <div className="flex items-center gap-3 mb-3">
            {item.image && <img src={item.image} alt={item.name} className="w-12 h-12 rounded-full object-cover" />}
            <div>
              <h3 className="font-bold text-slate-900" style={{ fontFamily: '"Noto Sans Devanagari", sans-serif' }}>{item.name}</h3>
              <p className="text-xs text-slate-500" style={{ fontFamily: '"Noto Sans Devanagari", sans-serif' }}>{item.designation}</p>
            </div>
          </div>
          <div className="flex gap-0.5 mb-2">
            {[...Array(item.rating || 5)].map((_, i) => <Star key={i} className="h-4 w-4 text-orange-500 fill-current" />)}
          </div>
          <p className="text-sm text-slate-600 line-clamp-3" style={{ fontFamily: '"Noto Sans Devanagari", sans-serif' }}>{item.review}</p>
        </div>
      )}
    />
  );
}
